import styled from "styled-components";
import ImgBgSite from "../../Images/BgSite.jpg";

export const BgFaleConosco = styled.section`
    background-image: url(${ImgBgSite});
    background-repeat: repeat;
`;

export const ForaFaleConosco = styled.div`
  width: 830px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${ImgBgSite});
  background-repeat: repeat;

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  input {
    height: 40px;
    margin-top: 10px;
    background-color: transparent;
    border: 2px solid #373737;
    border-radius: 6px;
    color: #fff;
    padding-left: 15px;
    font-size: 15px;
  }

  .InputMsg {
    border: 2px solid #373737;
    border-radius: 6px;
    background-color: transparent;
    margin-top: 10px;
    height: 80px;
    padding-left: 15px;
    padding-top: 10px;
    color: #fff;
  }


  button {
    background-color: #fc551e;
    border: 0px;
    font-weight: bold;
    font-size: 17px;
    color: #fff;
    width: 185px;
    height: 35px;
    margin-top: 25px;
    border-radius: 8px;
    cursor: pointer;
  }

  h2 {
    font-weight: 900;
    font-size: 37px;
    margin-top: 10px;
    margin-bottom: 25px;
  }

  .InputSelect {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;

    label {
      font-weight: bold;
      font-size: 19px;
      margin-right: 20px;
      color: #fc551e;
    }

    select {
      width: 75%;
      height: 35px;
      border-radius: 5px;
      background-color: #111111;
      color: #fff;
    }
  }

  .ForaAssessoria {
    width: 100%;
    margin-bottom: 30px;
    text-align: center;

    h4 {
      color: #fc551e;
      font-weight: bold;
      margin-top: 0px;
      margin-bottom: 15px;
    }

    span {
      font-size: 17px;
    }

    h5 {
      font-size: 15px;
    }
  }

  @media (max-width: 900px) {
    width: 90%;
  } 
  
  @media (max-width: 670px) {
    .InputSelect {
      select {
        width: 210px;
        height: 35px;
        border-radius: 5px;
      }
    }
  }
`;
